import { useCallback } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
import type { LiveGiftsAnimations } from '../../../types/lives/animations'

const LIVE_GIFTS_ANIMATIONS = '/LIVE-GIFTS-ANIMATIONS'

export function useUpdateLivePoints(onEvent?: () => void) {
  const liveId = useGlobalStore(useShallow((state) => state.liveId))
  // const liveUserId = useGlobalStore(useShallow((state) => state.liveUserId))
  const updateLivePoints = useGlobalStore(
    useShallow((state) => state.updateLivePoints),
  )

  const setPointsUserLive = useCallback(
    async ({ message }: LiveGiftsAnimations) => {
      // const pointsUsersLive = useGlobalStore.getState().pointsUsersLive

      const usersReturns = message?.returnForUser?.flatMap(
        ({ returnForUser }) => {
          return returnForUser
        },
      )

      if (usersReturns?.length) {
        const totalNewPoints = usersReturns.reduce((a, b) => {
          return a + (b?.value ?? 0)
        }, 0)

        updateLivePoints(totalNewPoints)
      }

      // avisa o componente mesmo sem returnForUser: qualquer gift muda o total
      // no server, e o refetch reconcilia o que o incremento não cobriu.
      onEvent?.()
    },
    [updateLivePoints, onEvent],
  )

  useSub<LiveGiftsAnimations>({
    endpoint: `${LIVE_GIFTS_ANIMATIONS}/${liveId}`,
    skip: !liveId,
    onData: setPointsUserLive,
  })
}
